import { ISwAppBeneficiariesApi } from "../../interfaces-and-types";

type TBeneficiaryUrls = { [key in keyof ISwAppBeneficiariesApi]: string };

const rootBeneficiaryUrl = "/beneficiaries";

export const beneficiaryUrls: TBeneficiaryUrls = {
  // bank transfer beneficiaries
  createBankTransferBeneficiary: `${rootBeneficiaryUrl}/create/bank-transfer`,
  getBankTransferBeneficiaries: `${rootBeneficiaryUrl}/list-bank-beneficiaries`,
  getBankTransferBeneficiaryById: `${rootBeneficiaryUrl}/bank-beneficiary/id`,
  deleteBankTransferBeneficiary: `${rootBeneficiaryUrl}/bank-beneficiary/id`,

  // gateway transfer beneficiaries
  createGatewayTransferBeneficiary: `${rootBeneficiaryUrl}/create/gateway-transfer`,
  getGatewayTransferBeneficiaries: `${rootBeneficiaryUrl}/list-gateway-beneficiaries`,
  getGatewayTransferBeneficiaryById: `${rootBeneficiaryUrl}/gateway-beneficiary/id`,
  deleteGatewayTransferBeneficiary: `${rootBeneficiaryUrl}/gateway-beneficiary/id`,
};
